'use client'

import Modal from '@components/primitives/Modal/index.client'
import { Text } from '@components/primitives/Text'
import { FILTER_VISIBILE } from '@modules/trials/search/const'
import type { AlgoliaSearchResultAndUiState } from '@modules/trials/search/getDataFromAlgolia'
import getUniqueTrialsFromTrialLocations from '@modules/trials/search/helpers/getUniqueTrialsFromTrialLocations'
import { useSearchParams } from 'next/navigation'
import { use, useEffect, useState } from 'react'
import ConditionFilterRefinementList from '../ConditionFilterRefinementList.client'
import { useToggleFilterModal } from '../Hooks/useToggleFilterModal'
import LocationFilterRefinementList from '../LocationFilterRefinementList'
import { PaidTrialFilterRefinementList } from '../PaidTrialFilterRefinementList.client'
import TreatmentFilterRefinementList from '../TreatmentFilterRefinementList.client'
import { TrialPhaseFilterRefinementList } from '../TrialPhaseFilterRefinementList.client'
import { TrialStatusFilterRefinementList } from '../TrialStatusFilterRefinementList.client'
import MobileFilterOverlayFooter from './MobileFilterOverlayFooter'

export default function MobileFilterOverlay({
  dataFromAlgoliaPromise,
}: {
  dataFromAlgoliaPromise: Promise<AlgoliaSearchResultAndUiState>
}) {
  const { algoliaResponse, searchLanderPageData } = use(dataFromAlgoliaPromise)
  const { activeConditionLabel, activeLocationLabel, activeTreatmentLabel } =
    searchLanderPageData

  const uniqueTrials = getUniqueTrialsFromTrialLocations(algoliaResponse.hits)
  const searchParams = useSearchParams() ?? new URLSearchParams()
  const toggleFilter = useToggleFilterModal()

  const [isVisible, setIsVisible] = useState(
    searchParams.has(FILTER_VISIBILE) ?? false,
  )

  useEffect(() => {
    setIsVisible(searchParams.has(FILTER_VISIBILE) ?? false)
  }, [searchParams])

  return (
    <Modal
      className='flex h-dvh flex-col justify-between overflow-hidden lg:w-1/3'
      footer={<MobileFilterOverlayFooter nbHits={uniqueTrials.length} />}
      onClose={isVisible ? toggleFilter : undefined}
      sectionClassName=''
      size='Full'
      title='Search Clinical Trials'
      visible={isVisible}
    >
      <div className='grid animate-blurOut grid-cols-1 gap-4'>
        <div className='flex flex-col items-start justify-start'>
          <Text className='pb-2 text-black antialiased' styleName='p-tiny'>
            Conditions
          </Text>
          <ConditionFilterRefinementList
            activeConditionLabel={activeConditionLabel}
          />
        </div>
        <div className='flex flex-col items-start justify-start'>
          <Text className='pb-2 text-black antialiased' styleName='p-tiny'>
            Locations
          </Text>
          <LocationFilterRefinementList
            activeLocationLabel={activeLocationLabel}
            inputClassName='pl-2'
          />
        </div>
        <div className='flex flex-col items-start justify-start'>
          <Text className='pb-2 text-black antialiased' styleName='p-tiny'>
            Treatment Type
          </Text>
          <TreatmentFilterRefinementList
            activeTreatmentLabel={activeTreatmentLabel}
          />
        </div>
        <div className='flex flex-col items-start justify-start'>
          <TrialPhaseFilterRefinementList />
        </div>
        <div className='flex flex-col items-start justify-start'>
          <TrialStatusFilterRefinementList />
        </div>
        <div className='flex flex-col items-start justify-start'>
          <PaidTrialFilterRefinementList />
        </div>
      </div>
    </Modal>
  )
}
